import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, FormGroup, Input, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: '',
      username: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
  }
  handleChange(name, value) {
    this.setState({
      [name]: value
    });
  }
  handleCustomerChange(event) {
    let value = event.target.value;
    // disallow spaces in customer name
    if (value.includes(' ')) {
      value = value.replace(/\s/g, '');
    }
    this.handleChange('customer', value);
  }
  handleResetClick() {
    const _this$state = this.state,
      customer = _this$state.customer,
      username = _this$state.username;
    const handleForgotPassword = this.props.handleForgotPassword;

    // save new password data.
    handleForgotPassword(customer, username);
  }
  handleUsernameChange(event) {
    this.handleChange('username', event.target.value);
  }
  render() {
    const _this$state2 = this.state,
      customer = _this$state2.customer,
      username = _this$state2.username;
    const onHide = this.props.onHide;

    // test component prefix
    const compName = 't-fp';
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: true,
      toggle: onHide,
      className: "".concat(compName, "-modal")
    }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(compName, "-title h2")
    }, "Reset Password"), /*#__PURE__*/React.createElement("div", {
      className: "".concat(compName, "-subtitle h4")
    }, "Please enter your Customer ID and username.")), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Input, {
      id: "customer",
      type: "text",
      value: customer || '',
      placeholder: "Customer name",
      className: "".concat(compName, "-customer"),
      onChange: this.handleCustomerChange
    })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Input, {
      id: "username",
      type: "text",
      value: username || '',
      placeholder: "Username",
      className: "".concat(compName, "-username"),
      onChange: this.handleUsernameChange
    })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onHide,
      id: "cancelButton",
      className: "".concat(compName, "-cancel")
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      id: "actionButton",
      disabled: !(customer && username),
      onClick: this.handleResetClick,
      className: "".concat(compName, "-reset")
    }, "Reset Password")));
  }
}
ForgotPassword.propTypes = {
  onHide: PropTypes.func.isRequired,
  handleForgotPassword: PropTypes.func.isRequired
};